import axios from "axios";
//Constants
import {
  GET_SERVICE_TYPE_API,
  SERVICE_TYPE_ID,
} from "./constants/pricing.constants";

export const getPricingPackage = async () => {
  return await axios.get(
    `${process.env.REACT_APP_BASE_URL}${GET_SERVICE_TYPE_API}?
          serviceTypeIDs=[${SERVICE_TYPE_ID}]
          &authenticationKey=${process.env.REACT_APP_API_KEY}
          &authenticationToken=${process.env.REACT_APP_API_TOKEN}`
  );
};

export const getContactRedirect = async (data) => {
  return await axios.get(
    `${process.env.REACT_APP_MAIN_API}/field-routes/customers`,
    { params: data }
  );
};

export const processInitialPayment = async (payload) => {
  return await axios.post(
    `${process.env.REACT_APP_MAIN_API}/field-routes/process-initial-payment`,
    payload
  );
};
